export const PARTNER_ACTIVATE_PATH_SUFFIX = 'partner-activate';

export const buildPartnerActivatePath = (partnerId) => {
  const id = String(partnerId ?? '').trim();
  if (!id) return '';
  return `/${encodeURIComponent(id)}/${PARTNER_ACTIVATE_PATH_SUFFIX}`;
};

export const isPartnerActivatePath = (pathname = '') => {
  const segments = String(pathname).split('/').filter(Boolean);
  return segments.length === 2 && segments[1] === PARTNER_ACTIVATE_PATH_SUFFIX;
};
